import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const xAuthKey = environment.xAuthKey;
    const token = localStorage.getItem('token') || '';
    const lang = localStorage.getItem('lang') || 'ar';

    const isApiUrl = request.url.includes('api.');
    const isGetTermsAndConditions =
      request.method === 'GET' && request.url.includes('terms-and-conditions');

    if (isApiUrl) {
      let headers = request.headers
        .set('Accept', 'application/json')
        .set('X-Authorization', xAuthKey)
        .set('Accept-Language', lang);

      // Set token only if not a GET request to terms-and-conditions
      if (!isGetTermsAndConditions) {
        headers = headers.set('Authorization', `Bearer ${token}`);
      }

      request = request.clone({ headers });
    }

    return next.handle(request);
  }
}
